module.exports = __webpack_public_path__ + "img/5188fe569a6c519cfe273d14248611d6.png";